import { FC } from 'react';
import { EstimateCrownIcon } from 'assets/icons';
import { CustomButton } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import CustomModal from 'components/custom-modal/CustomModal';
import { VoidFn } from 'types/baseTypes';

interface CancelSubscriptionModalProps {
  isOpen: boolean;
  handleClose: VoidFn;
  handleCancelSubscription: VoidFn;
  isLoading?: boolean;
}

const CancelSubscriptionModal: FC<CancelSubscriptionModalProps> = ({
  isOpen,
  handleClose,
  handleCancelSubscription,
  isLoading
}) => {
  return (
    <CustomModal open={isOpen} width={'md:w-[485px]'}>
      <div className="p-6">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-secondaryBtn">
          <EstimateCrownIcon />
        </div>
        <div className="mb-3.5 text-center text-xl font-bold text-heading">Cancel estimate subscription?</div>
        <div className="mb-6 text-center text-17px text-primaryText">
          Are you sure you want to cancel estimates subscription?
        </div>
        <div className="flex flex-col items-center justify-end gap-5">
          <CustomButton
            className="h-12 w-full"
            type={ButtonType.PRIMARY}
            onClick={handleCancelSubscription}
            isLoading={isLoading}
            id="confirm-cancel-subscription">
            Yes, cancel subscription
          </CustomButton>
          <CustomButton
            className="h-12 w-full"
            type={ButtonType.SECONDARY}
            onClick={handleClose}
            id="deny-cancel-subscription">
            No, don't cancel
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default CancelSubscriptionModal;
